import { Navigate, useLocation } from 'react-router-dom';
import { usePatientAuth } from './context/PatientAuthContext';

const isPatientMode = process.env.REACT_APP_PATIENT_MODE === 'true';

/**
 * IOO-225 – PatientProtectedRoute
 * Guards all authenticated patient account pages.
 * Saves intended path to sessionStorage before redirecting.
 */
export default function PatientProtectedRoute({ children }) {
  const { isAuthenticated } = usePatientAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    sessionStorage.setItem('patient_redirect_after_login', location.pathname + location.search);
    return <Navigate to={isPatientMode ? "/" : "/patient/login"} replace />;
  }

  return children;
}
